import { useMemo, useRef } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export type RecentSupporter = {
	uniqueKey: string;
	displayName: string;
	photo: string | undefined;
	relativeTimestamp: string;
};

type UseRecentSupportersListReturn = ModelHookResult<
	{ recentSupporters: RecentSupporter[] },
	{ onScrollSupporters: () => void }
>;

export function useRecentSupportersList(): UseRecentSupportersListReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const trackedRecentSupportersScrollRef = useRef(false);
	const track = useTracking();

	const recentSupportersList: RecentSupporter[] = useMemo(() => {
		if (!petition.recentSignersConnection || petition.recentSignersConnection.edges.length === 0) {
			return [
				{
					uniqueKey: petition.user.id,
					displayName: petition.user.displayName,
					photo: petition.user.photo?.userSmall.url,
					relativeTimestamp: petition.createdAtRelativeLocalized,
				},
			];
		}

		return petition.recentSignersConnection.edges.map((item) => {
			const displayName = item.user?.displayName || `${item.firstName} ${item.lastName}`;
			return {
				uniqueKey: item.user?.id || `${item.createdAt} ${displayName}`.replace(/\s+/g, '-'),
				displayName,
				photo: item.user?.photo?.userSmall.url,
				relativeTimestamp: item.createdAtRelativeLocalized,
			};
		});
	}, [petition]);

	const onScrollSupporters = () => {
		if (!trackedRecentSupportersScrollRef.current) {
			void track('signer_feed_scroll', {
				supporter_count: recentSupportersList.length,
			});
			trackedRecentSupportersScrollRef.current = true;
		}
	};

	return {
		data: {
			recentSupporters: recentSupportersList,
		},
		actions: {
			onScrollSupporters,
		},
	};
}
